export default {
  "club_currency_not_configured": "Moneta Club non configurata",
  "please_configure_a_currency_in_control_to_view_cost_comparisons": "Si prega di configurare una valuta in Controllo per visualizzare i confronti dei costi.",
  "currency_lookup_failed": "Ricerca della valuta fallita",
  "defaulted_to_gbp_until_the_currency_service_is_available": "Predefinito a GBP fino a quando il servizio di valuta non è disponibile.",
  "failed_to_load_budgets": "Non caricate i bilanci",
  "failed_to_load_budget_references": "Non caricare riferimenti di bilancio",
  "sent_to_budget": "Invia a Bilancio",
  "budget_line_created_for_board_approval": "Linea di bilancio creata per l'approvazione del Consiglio.",
  "failed_to_send_to_budget": "Non inviare a budget",
  "failed_to_award_rfq": "Non ha premiato RFQ",
  "cost_advantage": "Vantaggio dei costi",
  "quality_advantage": "Vantaggio di qualità",
  "service_advantage": "Vantaggio del servizio",
  "head_to_head_bidder_battle": "Testa a mano Bidder Battle",
  "select_rfq_to_compare": "Selezionare RFQ per confrontare",
  "cost_weight": "Costo Peso",
  "quality_weight": "Peso di qualità",
  "service_weight": "Peso di servizio",
  "total_weight": "Peso totale:",
  "total_weight_must_be_100_currently": "Il peso totale deve essere ≤ 100%. Attualmente",
  "reduce_by": "% (riduzione)",
  "reset_to_template": "Ripristino del modello",
  "set_at_least_one_weight_above_0_to_run_the_comparison": "Impostare almeno un peso sopra il 0% per eseguire il confronto.",
  "calculating": "Calcolo...",
  "run_battle_analysis": "Esegui l'analisi della battaglia",
  "calculating_battle_outcome": "Calcolo del risultato della battaglia...",
  "winner": "Vincitore",
  "tie": "Cravatta",
  "lead_margin": "Margine di lead",
  "biggest_differentiator": "Più grande Differenziatore",
  "challenger_a": "Sfidante A",
  "winner_32": "VINCITORE",
  "tie_33": "TELEFONO",
  "total_cost": "Costo totale",
  "final_score_10": "Punteggio finale (/10)",
  "evaluate": "Valutare",
  "cost_score": "Punteggio dei costi:",
  "quality_score": "Punteggio di qualità:",
  "service_score": "Punteggio di servizio:",
  "unknown": "Sconosciuto",
  "send_to_budget": "Invia a Budget",
  "awarding": "Assegnazione...",
  "award": "Premio",
  "this_rfq_was_sent_to_budget_with_a_different_bid": "Questo RFQ è stato inviato a bilancio con un'offerta diversa.",
  "challenger_b": "Sfidante B",
  "awaiting_submissions": "Risveglio delle sottomissioni",
  "awaiting_more_bidder_submissions_for_this_rfq": "Risveglio di più domande di offerente per questo RFQ.",
  "category_breakdown": "Ripartizione della categoria",
  "quality_score_49": "Punteggio di qualità",
  "service_score_50": "Scoperto di servizio",
  "ready_for_battle": "Pronti per la battaglia!",
  "no_submissions_available_yet_for_the_selected_rfq": "Non sono ancora disponibili presentazioni per il RFQ selezionato.",
  "select_an_rfq_with_multiple_submissions_to_start_the_head_to_head": "Selezionare un RFQ con più sottomissioni per avviare il confronto testa a testa",
  "no_rfqs_available": "Nessun RFQ disponibile",
  "there_are_no_rfqs_to_compare_please_create_or_import_rfqs_to_use_": "Non ci sono RFQ da confrontare. Si prega di creare o importare RFQ per utilizzare questa funzione.",
  "award_without_board_approval": "Premio senza approvazione del consiglio?",
  "are_you_sure_board_approval_is_not_required_for_awarding_this_bid": "Sei sicuro che l'approvazione del Consiglio non sia necessaria per l'aggiudicazione di questa offerta? Questa azione verrà registrata.",
  "cancel": "Annulla",
  "yes_award_anyway": "Sì, premio comunque",
  "select_an_existing_budget_to_create_a_board_approved_earmark": "Selezionare un budget esistente per creare un segno di orecchio approvato dalla scheda.",
  "budget": "Bilancio",
  "no_budgets_available": "Nessun budget disponibile",
  "gl_account": "Conto di contabilità generale",
  "department": "Dipartimento",
  "owner_optional": "Proprietario (opzionale)",
  "search_staff_by_name_or_email": "Ricerca personale per nome o e-mail",
  "unassigned": "Non assegnato",
  "searching": "Ricerca…",
  "no_matches": "Nessuna corrispondenza",
  "type_at_least_2_characters_to_search": "Digita almeno 2 caratteri per cercare.",
  "searching_staff": "Personale di ricerca...",
  "select_a_staff_member_to_assign_ownership": "Selezionare un membro del personale per assegnare la proprietà.",
  "category": "Categoria",
  "total_amount": "Importo totale",
  "currency": "Valuta:",
  "month_allocation": "Stanziamento mensile",
  "single_month_charge": "Supplemento mese singolo",
  "split_across_months": "Spalato per mesi",
  "month": "Mese",
  "amount": "Importo",
  "remove": "Rimuovi",
  "add_month": "Aggiungi mese",
  "allocated_total": "Totale assegnato:",
  "allocation_total_must_match_the_total_amount": "Il totale dell'allocazione deve corrispondere all'importo totale.",
  "sending": "Invio…",
  "contract_renewal_alerts": "Avvisi di rinnovo del contratto",
  "ai_powered_contract_renewal_predictions_and_recommendations": "Previsioni e raccomandazioni per il rinnovo dei contratti alimentati dall'IA",
  "critical": "Critico",
  "refresh": "Aggiorna",
  "upcoming_renewals": "Renews in arrivo",
  "next_30_days": "I prossimi 30 giorni",
  "critical_risk": "Rischio critico",
  "require_attention": "Requisisci attenzione",
  "total_value": "Valore totale",
  "annual_contracts": "Contratti annuali",
  "avg_performance": "Prestazioni di Avg",
  "out_of_100": "su 100",
  "all_contracts": "Tutti i contratti",
  "risk": "Rischio",
  "contract": "Contratto",
  "contract_ends": "Fine del contratto",
  "days_to_decide": "giorni per decidere",
  "current_value": "Valore attuale",
  "predicted_increase": "% di aumento previsto",
  "performance_score": "Punteggio delle prestazioni",
  "alternatives": "Alternative",
  "bidders": "offerenti",
  "ai_recommendation": "AI Raccomandazione:",
  "risk_factors": "Fattori di rischio:",
  "last_review": "Ultima recensione:",
  "start_negotiation": "Inizia la negoziazione",
  "schedule_review": "Recensione del programma",
  "no_contract_renewals": "Nessun rinnovo del contratto",
  "no_contracts_match_the_selected_risk_level": "Nessun contratto corrisponde al livello di rischio selezionato.",
  "usda_market_news": "Notizie di mercato USDA",
  "food_agricultural_commodities": "Prodotti alimentari e agricoli",
  "eia_energy_data": "Dati energetici EIA",
  "fuel_prices_and_energy_costs": "Prezzi del carburante e costi energetici",
  "bureau_of_labor_statistics": "Ufficio di statistica del lavoro",
  "cpi_ppi_indices_for_service_categories": "Indici CPI/PPI per categorie di servizi",
  "wine_searcher": "Vino-ricercatore",
  "global_wine_pricing_database": "Database dei prezzi del vino globale",
  "liv_ex": "Liv-ex",
  "fine_wine_trading_platform": "Piattaforma di trading del vino",
  "mintec": "Min.",
  "food_ingredient_pricing": "Prezzi degli ingredienti alimentari",
  "opis": "OPERIORE",
  "intraday_fuel_pricing": "Prezzo del carburante Intraday",
  "price_index_data_sources": "Indice dei prezzi Fonti dati",
  "core_data_sources": "Principali fonti di dati",
  "included": "Incluso",
  "updates": "Aggiornamenti:",
  "enhanced_data_sources": "Fonti di dati migliorate",
  "available": "Disponibile",
  "premium_feature": "Caratteristica Premium",
  "enhanced_data_sources_provide_deeper_market_intelligence_with_rea": "Le fonti di dati migliorate forniscono un'intelligenza di mercato più profonda con prezzi in tempo reale, categorie speciali e analisi avanzate. Contattate il vostro rappresentante Privana per abilitare questi feed premium.",
  "data_sources_update_automatically_changes_take_effect_within_1_ho": "Le fonti di dati si aggiornano automaticamente. Le modifiche hanno effetto entro 1 ora.",
  "save_settings": "Salvare le impostazioni",
  "failed_to_load_bidders": "Non ha caricato gli offerenti",
  "all_bidders": "Tutte le scale",
  "master_directory_of_vendors_across_all_rfqs": "Master directory di fornitori in tutti i RFQ",
  "search_by_name_or_email": "Ricerca per nome o e-mail",
  "status": "Stato",
  "all": "Tutti",
  "active": "Attivo",
  "inactive": "Inattivo",
  "name": "Nome",
  "contact": "Contatto",
  "email": "E-mail",
  "website": "Sito web",
  "phone": "Telefono",
  "last_updated": "Ultimo aggiornamento",
  "loading_bidders": "Caricamento in corso...",
  "no_bidders_found": "Nessun offerente trovato.",
  "showing_0_bidders": "Mostrare 0 offerenti",
  "previous": "Precedente",
  "next": "Avanti",
  "active_rfqs": "RFQ attivi",
  "data_unavailable": "Dati non disponibili",
  "total_submissions": "Totale delle emissioni",
  "submitted_bids": "offerte presentate",
  "club_currency": "valuta del club",
  "avg_response_time": "Tempo di risposta Avg",
  "to_submission": "a presentazione",
  "cost_savings_vs_budget": "Risparmio dei costi contro il budget",
  "weighted_across_rfqs": "ponderato sulle richieste di preventivo",
  "urgent_rfqs": "RFQ urgenti",
  "no_urgent_rfqs": "Nessun RFQ urgente",
  "no_deadline": "Nessuna scadenza",
  "recent_activity": "Attività recenti",
  "no_recent_activity": "Nessuna attività recente",
  "rfq_processing_time": "Tempo di elaborazione RFQ",
  "average_response_time": "tempo medio di risposta",
  "bidder_participation": "Partecipazione del offerente",
  "avg_submissions_per_rfq": "avg sottomissioni per RFQ",
  "cost_savings": "Risparmio di costi",
  "vs_budgeted_amounts": "contro gli importi di bilancio",
  "bidder_performance_heatmap": "Bicipite performance heatmap",
  "high_risk_only": "Sollevato rischio",
  "medium_risk_only": "Rischio medio",
  "low_risk_only": "Rischio basso",
  "avg_lead_time": "Tempo medio di approvvigionamento",
  "days": "giorni",
  "avg_price_variance": "Variazione dei prezzi di Avg",
  "avg_reliability": "Affidabilità Avg",
  "high_risk": "Rischio alto",
  "risk_188": "rischio",
  "lead_time": "Tempo di consegna:",
  "price_variance": "Varianza di prezzo:",
  "reliability": "Affidabilità:",
  "sla_breaches": "Sla violazioni:",
  "risk_193": "Rischio:",
  "heat_score": "Punteggio di calore:",
  "no_bidder_data": "Nessun dato di offerente",
  "click_generate_demo_data_to_see_bidder_locations_and_performance_": "Fare clic su \"Generate Demo Data\" per visualizzare le posizioni e le metriche delle prestazioni dei offerenti",
  "legend": "La leggenda",
  "low_risk_bidders": "Bidder a basso rischio",
  "medium_risk_bidders": "Bidder a rischio medio",
  "high_risk_bidders": "Bidder ad alto rischio",
  "circle_size_indicates_heat_score_larger_higher_risk_variance": "La dimensione del cerchio indica il punteggio di calore (più grande = più alto rischio/varianza)",
  "new_procurement_request": "Nuova richiesta di acquisto",
  "request_title": "Richiesta Titolo *",
  "brief_description_of_what_you_need": "Breve descrizione di ciò di cui hai bisogno",
  "detailed_description": "Descrizione dettagliata *",
  "provide_detailed_requirements_specifications_quantities_etc": "Fornire requisiti dettagliati, specifiche, quantità, ecc.",
  "your_department": "Il tuo dipartimento",
  "select_category": "Seleziona la categoria",
  "products": "Prodotti",
  "services": "Servizi",
  "maintenance": "Manutenzione",
  "technology": "Tecnologia",
  "food_beverage": "Alimenti e bevande",
  "other": "Altro",
  "estimated_budget": "Bilancio stimato",
  "required_by_date": "Obbligatorio da data",
  "urgency": "Urgenza",
  "low": "Basso",
  "medium": "Medio",
  "high": "Alto",
  "urgent": "Urgente",
  "submit_request": "Invia richiesta",
  "unable_to_generate_rfq": "Incapace di generare RFQ",
  "ai_powered_rfq_builder": "AI-Powered RFQ Costruttore",
  "describe_your_procurement_need": "Descrivi la tua richiesta di acquisto",
  "what_do_you_need_be_as_specific_as_possible": "Cosa ti serve? (Sii il più specifico possibile)",
  "e_g_we_need_a_weekly_linen_service_for_our_dining_room_including_": "Ad esempio, 'Abbiamo bisogno di un servizio di biancheria settimanale per la nostra sala da pranzo, tra cui tovaglie, tovaglioli e asciugamani da cucina. Serviamo circa 300 copertine a settimana e abbiamo bisogno di qualità premium con la garanzia di rimozione della macchia stessa...'",
  "ai_will_help_you_with": "AI vi aiuterà con:",
  "professional_rfq_structure_and_language": "• Struttura professionale RFQ e lingua",
  "industry_specific_requirements_and_compliance": "• Requisiti e conformità specifici per l'industria",
  "evaluation_criteria_recommendations": "• Raccomandazioni sui criteri di valutazione",
  "contract_terms_suggestions": "• Suggerimenti sui termini di contratto",
  "line_item_specifications": "• Specifiche del prodotto della linea",
  "ai_generated_rfq_review_edit": "Richiesta di preventivo generata dall’IA – Rivedi e modifica",
  "title": "Titolo",
  "description": "Descrizione",
  "urgent_rfq": "RFQ urgente",
  "flag_for_expedited_procurement_review": "Bandiera per una revisione degli appalti accelerata.",
  "link_budget_line_staff_only": "Linea di bilancio di collegamento (solo agente)",
  "clear_selection": "Selezione chiara",
  "budget_amounts_remain_hidden_from_bidders": "Gli importi di bilancio rimangono nascosti agli offerenti.",
  "line_items": "Elementi di linea",
  "add_item": "Aggiungi articolo",
  "item_name": "Nome dell'articolo",
  "unit_of_measure": "Unità di misura",
  "e_g_each_kg_hours": "ad esempio, ciascuno, kg, ore",
  "quantity": "Quantità",
  "est_unit_cost": "Costo unitario ($)",
  "specifications": "Specifiche",
  "detailed_specifications_quality_requirements_etc": "Specifiche dettagliate, requisiti di qualità, ecc.",
  "rfq_summary": "Riassunto RFQ",
  "urgent_252": "Urgente:",
  "yes": "Sì",
  "budget_line": "Linea di bilancio:",
  "line_items_255": "Articoli di linea (",
  "generating": "Generando...",
  "generate_rfq": "Generare RFQ",
  "review_publish": "Rivedi e pubblica",
  "create_rfq": "Creare RFQ",
  "cost": "Costo",
  "quality": "Qualità",
  "service": "Servizio",
  "failed_to_load_rfq": "Non caricato RFQ",
  "please_configure_a_currency_in_control_before_creating_submission": "Si prega di configurare una valuta in Controllo prima di creare presentazioni.",
  "bidder_invited_no_email_sent": "Bidder invitato (nessuna e-mail inviata)",
  "invite_created_email_failed": "Invito creato (email non riuscita)",
  "failed_to_invite_bidder": "Non ha invitato il offerente",
  "bidder_name_is_required": "Il nome del offerente è richiesto",
  "failed_to_create_bidder": "Non è riuscito a creare il offerente",
  "status_updated": "Stato aggiornato",
  "failed_to_update_status": "Non è riuscito ad aggiornare lo stato",
  "scoring_template_updated": "Modello di punteggio aggiornato",
  "failed_to_update_scoring_template": "Non è stato possibile aggiornare il modello di punteggio",
  "enter_scores_before_saving": "Inserisci i punteggi prima di salvare",
  "evaluation_saved": "Valutazione salvata",
  "failed_to_save_evaluation": "Non riuscito a salvare la valutazione",
  "select_a_bidder_first": "Selezionare un offerente prima",
  "please_configure_a_currency_before_creating_submissions": "Si prega di configurare una valuta prima di creare presentazioni.",
  "submission_saved": "Salvataggio della sottomissione",
  "failed_to_save_submission": "Non riuscito a salvare la presentazione",
  "failed_to_promote_supplier": "Non è riuscito a promuovere il fornitore",
  "portal_link_copied": "Portale link copiato",
  "failed_to_copy_portal_link": "Non è riuscito a copiare il link del portale",
  "portal_link_regenerated": "Portal link rigenerato",
  "failed_to_regenerate_link": "Non è riuscito a rigenerare il link",
  "failed_to_send_invite_email": "Non ha inviato email di invito",
  "rfq_detail": "Dettaglio richiesta di preventivo",
  "back_to_list": "Torna alla lista",
  "loading_rfq_details": "Caricamento dettagli RFQ...",
  "rfq_not_found": "RFQ non trovato.",
  "uncategorized": "Non categorizzato",
  "created": "· Creato",
  "invited": "· Invitato",
  "submitted": "· Inviato",
  "overview": "Panoramica",
  "bidders_296": "Offerenti",
  "submissions": "Sostanze",
  "evaluation": "Valutazione",
  "activity": "Attività",
  "deadline": "Scadenza:",
  "type": "Tipo",
  "set_status": "Impostare lo stato",
  "awarded": "Premiato",
  "awarded_bidder": "Bidder premiato",
  "view_supplier": "Visualizza Fornitore",
  "promote_to_supplier": "Promuovere al fornitore",
  "award_this_rfq_to_promote_the_winning_bidder_into_the_suppliers_m": "Premi questo RFQ per promuovere il bidder vincente nel modulo Fornitori.",
  "invited_bidders": "Bidders invitati",
  "invited_309": "invitato invitato",
  "search_bidders": "Cerca offerte",
  "invite": "Invito",
  "add_a_new_bidder": "Aggiungi un nuovo offerente",
  "bidder_name": "Nome della scala",
  "email_optional": "Email (opzionale)",
  "create_invite": "Creare & Invite",
  "no_bidders_invited_yet": "Nessun offerente invitato ancora.",
  "status_317": "Stato:",
  "submitted_318": "Inviato",
  "more_details": "Maggiori dettagli",
  "last_viewed": "Ultimo visualizzato",
  "link_expires": "Il collegamento scade",
  "revoked": "Questo link di invito è stato revocato. Si prega di richiedere un nuovo link dal club.",
  "invite_email_sent": "Invitare e-mail inviata",
  "invite_email_failed": "Invita l'e-mail non riuscita:",
  "submission_confirmation_sent": "Conferma di ammissione inviata",
  "submission_confirmation_failed": "La conferma di invio è fallita:",
  "copy_link": "Copia il link",
  "regenerate_link": "Rigenerare link",
  "send_invite_email": "Inviare invito e-mail",
  "received": "ricevuto",
  "bidder": "Bilancia",
  "select_invited_bidder": "Seleziona il offerente invitato",
  "notes": "Note",
  "currency_334": "Valuta",
  "club_currency_not_configured_submissions_are_disabled": "Moneta Club non configurata. Le emissioni sono disabilitate.",
  "upload_quote_pdf": "Citazione di carico (PDF )",
  "saving": "Salvataggio…",
  "save_submission": "Salvare la sottomissione",
  "no_submissions_yet": "Non ci sono ancora messaggi.",
  "awarded_bid": "Bid premiato",
  "no_notes": "Nessuna nota",
  "view": "Visualizza",
  "scoring_template": "Modello di punteggio",
  "weight": "Peso (%)",
  "save_template": "Salva il modello",
  "weights_must_add_up_to_100": "I pesi devono aggiungere fino al 100%.",
  "no_submissions_available_to_evaluate": "Nessuna presentazione disponibile per valutare.",
  "total_score": "Punteggio totale:",
  "needs_evaluation": "Bisogno di valutazione",
  "cost_rating_0_10": "Valutazione dei costi (0-10)",
  "quality_rating_0_10": "Valutazione della qualità (0-10)",
  "service_rating_0_10": "Valutazione del servizio (0-10)",
  "save_evaluation": "Risparmio di valutazione",
  "requires_board_approved_budget": "Richiede un bilancio approvato dal Consiglio.",
  "computed_total": "Totale calcolato:",
  "linked_to_budget": "Collegamento al bilancio",
  "no_budget_linked_yet_use_evaluation_to_send_a_bid_to_budget": "Non c'è ancora alcun budget legato. Utilizzare la valutazione per inviare un'offerta al bilancio.",
  "no_activity_yet": "Ancora nessuna attività.",
  "this_will_create_a_supplier_record_from_the_awarded_bidder_and_li": "Questo creerà un record del Fornitore dal offerente assegnato e lo collegherà a questo RFQ.",
  "also_create_a_contract_for_renewals": "Inoltre creare un contratto per i rinnovi",
  "optional_contract_details_will_be_attached_to_the_new_supplier": "I dettagli contrattuali opzionali saranno allegati al nuovo fornitore.",
  "contract_name": "Nome del contratto",
  "start_date": "Data di inizio",
  "end_date": "Data di fine",
  "renewal_type": "Tipo di rinnovo",
  "notice_period_days": "Periodo di preavviso",
  "value": "Valore",
  "promoting": "Promuovere...",
  "confirm": "Conferma",
  "submission": "Soppressione",
  "previous_371": "← Precedente",
  "of": "di",
  "next_373": "Il prossimo →",
  "pricing_summary": "Riepilogo dei prezzi",
  "lead_time_375": "Tempo di consegna",
  "validity_date": "Data di validità",
  "no_notes_provided": "Non ci sono note fornite.",
  "exclusions": "Conclusioni",
  "assumptions": "Assunzioni",
  "attachments": "Attacchi",
  "copy_bidder_portal_link": "Copiare il link del portale del offerente",
  "download": "Scarica",
  "no_files_attached": "Nessun file allegato.",
  "last_updated_384": "Ultimo aggiornamento",
  "failed_to_load_rfqs": "Non caricare RFQs",
  "rfq_status_updated": "Stato della richiesta di preventivo aggiornato",
  "requests_for_quotation_rfqs": "Richieste di preventivo (RFQ)",
  "loading_rfqs": "Caricamento RFQs...",
  "invited_389": "Invitato:",
  "submitted_390": "Inviato:",
  "created_391": "Creato:",
  "invite_more_bidders": "Invita più offerenti",
  "send_to_bidders": "Invia a Bidders",
  "view_details": "Visualizza dettagli",
  "change_status": "Cambia lo stato",
  "no_rfqs_found": "Nessun RFQ trovato.",
  "real_time_price_index": "Indice dei prezzi in tempo reale",
  "live_usda_food_commodity_pricing_and_bidder_comparisons": "Live USDA prodotti alimentari prezzi e confronti di offerenti",
  "usda_live_data": "Usda dati dal vivo",
  "updating": "Aggiornamento...",
  "price_index_enhanced_coming_soon": "Indice dei prezzi Migliorato in arrivo presto",
  "more_categories_with_premium_data_feeds_fuel_linens_wine_technolo": "- Altre categorie con data feed premium (carburante, biancheria, vino, tecnologia).",
  "price_alerts": "avvisi sul prezzo:",
  "significant_price_movements_detected_in": "Movimenti significativi dei prezzi rilevati",
  "5_week_trend_flow": "Flusso di tendenza 5-Week",
  "select_an_item_below_to_view_its_5_week_price_trend": "Seleziona un articolo qui sotto per visualizzare il suo trend di prezzo di 5 settimane.",
  "all_categories": "Tutte le categorie",
  "no_live_data": "Nessun dato live",
  "vs": "vs.",
  "vs_club_actual": "rispetto al consuntivo del club",
  "club_pays": "Pagamenti Club: $",
  "volatility": "Volatilità",
  "awaiting_next_usda_update": "Risveglio del prossimo aggiornamento USDA",
  "data_sources_schedule": "Fonti di dati & pianificazione:",
  "usda_market_news_service": "Servizio stampa di mercato USDA",
  "last_updated_416": "Ultimo aggiornamento:",
  "next_update": "Prossimo aggiornamento:",
  "updates_automatically_every_monday_at_8_00_am_local_time_or_click": "Aggiorna automaticamente ogni lunedì alle 8:00 ora locale, o fare clic su Aggiorna per l'aggiornamento immediato.",
  "enhanced_available": "Migliorato disponibile",
  "contact_support_for_fuel_wine_linens_more": "Contatta l’assistenza per carburante, vino, biancheria e altro",
  "no_usda_price_data_available": "Nessun dato di prezzo USDA disponibile",
  "click_refresh_to_load_current_usda_commodity_pricing_data": "Fare clic su aggiornamento per caricare i dati attuali dei prezzi delle materie prime USDA.",
  "load_usda_data": "Caricare i dati USDA",
  "unable_to_prepare_invitation_emails": "Incapace di preparare e-mail di invito",
  "review_bidder_emails": "Recensione e-mail di offerente",
  "source": "Fonte",
  "existing_bidder": "Bidder esistente",
  "new_bidder": "Nuovo offerente",
  "search_all_bidders": "Cerca tutti gli offerenti",
  "type_at_least_2_characters": "Digitare almeno 2 caratteri",
  "no_email": "nessuna e-mail",
  "company_name": "Nome della Società",
  "contact_first_name": "Contatto nome",
  "contact_last_name": "Contatto cognome",
  "existing_bidder_contact_details_are_read_only_here_edit_the_canon": "Qui vengono riproposti i dettagli di contatto della bifora. Modificare il record canonico in All Bidders prima di preparare questo invito.",
  "this_bidder_or_email_is_already_selected": "Questo offerente o e-mail è già selezionato.",
  "add_bidder": "Aggiungi il carrello",
  "your_microsoft_mailbox_is_not_available_connect_or_reconnect_it_i": "La tua casella di posta Microsoft non è disponibile. Collegare o riconnetterlo in Comunicazioni prima di inviare. Privana non tornerà all'e-mail di sistema.",
  "generating_drafts_creates_the_canonical_rfq_bidder_relationship_s": "Generando bozze crea la relazione canonica RFQ-bidder, in modo che il conte Invited può aumentare prima che l'e-mail venga inviata. Il progetto, inviato e gli stati di consegna falliti rimangono tracciati separatamente.",
  "generate_email_drafts": "Generare bozze di e-mail",
  "from": "Da",
  "to": "A",
  "recipient_is_tied_to_the_selected_canonical_bidder_contact_edit_t": "Recipiente è legato al contatto di offerente canonico selezionato. Modificare il offerente in All Bidders per cambiarlo.",
  "subject": "Oggetto",
  "body": "Corpo",
  "include_online_quote_submission_link": "Includi il link di presentazione del preventivo online",
  "adds_a_secure_privana_link_to_this_email_so_the_bidder_can_submit": "Aggiunge un collegamento sicuro Privana a questa e-mail in modo che il offerente può inviare la loro quotazione direttamente in questo RFQ. Spegnere questo se si desidera che il offerente di rispondere o inviare la loro quotazione a voi per e-mail invece.",
  "retry_this_recipient": "Recuperare questo destinatario",
  "reconciliation_pending": "riconciliazione pendente",
  "recheck_delivery": "Ricontrollare la consegna",
  "send_this_email": "Invia questa e-mail",
  "sent": "inviato",
  "close": "Chiudi",
  "retry_unsent_recipients": "Recuperare i destinatari non inviati",
  "send_all_emails": "Invia tutte le email",
  "professional": "Professionista",
  "formal_and_business_like": "Formale e business",
  "friendly": "Amichevole",
  "warm_and_collaborative": "Caldo e collaborativo",
  "stern": "Poppa",
  "firm_and_direct": "Firma e diretta",
  "diplomatic": "Diplomatico",
  "tactful_and_careful": "Affettuoso e attento",
  "video_call": "Videochiamata",
  "phone_call": "Chiamata telefonica",
  "in_person_meeting": "Incontro in persona",
  "start_negotiation_469": "Inizio Negoziazione -",
  "schedule_review_470": "Calendario di revisione -",
  "recipients": "Recipienti",
  "bidder_contacts": "Contatti per Bidder",
  "primary": "Primario",
  "cc_staff_members": "Membri del personale del CC",
  "cc_custom_emails": "E-mail personalizzate CC",
  "enter_email_address": "Inserisci l'indirizzo email",
  "email_content": "Contenuto e-mail",
  "tone": "Tono",
  "meeting_type": "Tipo di riunione",
  "generate_ai_content": "Generare contenuti AI",
  "email_subject": "Oggetto dell'email",
  "message": "Messaggio",
  "compose_your_email_message": "Componi il tuo messaggio e-mail...",
  "send_email": "Invia email",
  "bidder_portal": "Portale di Bidder",
  "external_bidder_access_is_now_available": "Ora è disponibile l'accesso al offerente esterno.",
  "bidder_portal_enabled": "Portale Bidder abilitato",
  "external_bidder_access_is_enabled_from_rfq_detail_via_invite_link": "L'accesso al bidder esterno è abilitato dal dettaglio RFQ tramite link di invito.",
  "jan": "Jan.",
  "feb": "Febbraio",
  "mar": "Mar Mediterraneo",
  "apr": "A.",
  "may": "Maggio",
  "jun": "Jun",
  "jul": "Luglio",
  "aug": "Agosto",
  "sep": "Segreto",
  "oct": "Ottobre",
  "nov": "No.",
  "dec": "Dec.",
  "operating": "Funzionamento operativo",
  "capex": "Caps.",
  "select_gl_account": "Selezionare account GL",
  "failed_to_load_procurement_data": "Non caricare i dati di approvvigionamento",
  "failed_to_create_rfq": "Non riuscita a creare RFQ",
  "create_professional_rfqs_with_ai_assistance": "Creare RFQ professionali con assistenza AI",
  "start_new_rfq": "Avviare il nuovo RFQ",
  "phase_1": "Fase 1",
  "missing_required_fields": "Campi obbligatori mancanti",
  "contact_name_email_total_amount_and_currency_are_required_to_subm": "Il nome del contatto, l'email, l'importo totale e la valuta sono tenuti a presentare.",
  "submission_locked": "Sottomissione chiusa",
  "this_offer_has_already_been_submitted_and_can_no_longer_be_edited": "Questa offerta è già stata presentata e non può più essere modificata.",
  "deadline_passed": "Termine ultimo per la presentazione",
  "the_submission_deadline_has_passed_please_contact_the_club": "Il termine di presentazione è passato. Contattare il club.",
  "file_uploaded": "File caricati",
  "file_upload_failed": "Caricamento file non riuscito",
  "loading_invitation": "Caricamento in corso...",
  "bidder_submission_portal": "Portale della sottomissione di Bidder",
  "request_for_quote": "Richiesta di preventivo",
  "category_520": "Categoria:",
  "type_521": "· Tipo:",
  "company": "Azienda:",
  "your_offer_is_locked_editing_is_unavailable": "La vostra offerta è bloccata, la modifica non è disponibile.",
  "contact_name": "Nome del contatto",
  "contact_email": "E-mail di contatto",
  "total_price": "Prezzo totale",
  "currency_is_not_configured_please_contact_the_club_before_submitt": "La valuta non è configurata. Si prega di contattare il club prima di inviare.",
  "lead_time_days": "Tempo di consegna (giorni)",
  "validity_until": "Validità fino a quando",
  "accepted_pdf_images_word_documents_or_text_files_max_10mb": "Accettato: PDF , immagini, documenti di Word o file di testo (max 10MB).",
  "save_draft": "Salvare il progetto",
  "submit_offer": "Invia l'offerta",
  "retry": "Riprova.",
  "serverError": "Errore del server",
  "budgetUnknown": "Stato di bilancio sconosciuto (refresh).",
  "awardedOverride": "Premiato (override)",
  "rfqAwarded": "RFQ assegnato",
  "budgetLoading": "Caricamento di budget...",
  "budgetSelect": "Seleziona un budget",
  "budgetLinesLoading": "Caricamento delle linee di bilancio...",
  "budgetLineSelect": "Seleziona una linea di bilancio",
  "budgetLineSearch": "Cerca le linee di bilancio...",
  "budgetLineError": "Incapace di caricare le linee di bilancio.",
  "budgetLinesEmpty": "Nessuna linea di bilancio trovata.",
  "retryMoment": "Si prega di riprovare in un momento.",
  "no": "No",
  "submittedSuccessfully": "Inviato con successo",
  "draftSaved": "Bozza salvata",
  "offerSubmitted": "La tua offerta e' stata presentata al club.",
  "draftReturn": "È possibile tornare a aggiornare questo progetto in qualsiasi momento prima della scadenza.",
  "submissionFailed": "Inadempimento di uno Stato",
  "draftFailed": "Progetto di salvataggio fallito",
  "expired": "Questo link di invito è scaduto. Si prega di richiedere un nuovo link dal club.",
  "invalid": "Questo link di invito non è disponibile o non è disponibile.",
  "reconciling": "La consegna di Microsoft è riconciliata. Privana non si rivenderà fino a quando il risultato del fornitore è noto.",
  "sendFailed": "Invia fallo",
  "supplierLinked": "Fornitore già collegato",
  "supplierCreated": "Fornitore creato",
  "copied": "Collegamento copiato a clipboard.",
  "newCopied": "Nuovo link copiato a clipboard.",
  "selectGl": "Selezionare account GL",
  "searchGl": "Cerca i conti GL...",
  "emptyGl": "Nessun account GL trovato.",
  "selectDepartment": "Seleziona il reparto",
  "searchDepartment": "Dipartimenti di ricerca...",
  "emptyDepartment": "Nessun dipartimento trovato.",
  "primaryContact": "Contatto primario",
  "selectRecipient": "Si prega di selezionare almeno un contatto di offerente per inviare a.",
  "emailFailed": "Non inviare e-mail. Si prega di riprovare.",
  "enter": "Inserisci",
  "showing": "Mostrando {start} – {end} di {total}",
  "daysValue": "{count} giorni",
  "due": "A causa: {date}",
  "publishedActivity": "RFQ pubblicato: {title}",
  "submissionActivity": "Sottomissione da {name}",
  "regenerateConfirm": "Rigenerare il link del portale per {name} ? Il link precedente cesserà di funzionare.",
  "expires": "Scade {date}",
  "newExpires": "Nuovo link scade {date}",
  "inviteEmailed": "Invitato e-mail a {recipient}",
  "toRecipient": " a {recipient}",
  "emailSent": "E-mail inviata a {count} destinatari!",
  "negotiationSubject": "Negoziazione contrattuale - {name}",
  "reviewSubject": "Riunione di revisione dei contratti - {name}",
  "portalUnavailable": "L'accesso alla scala non è disponibile. Contatta il club.",
  "enums": {
    "status": {
      "draft": "Bozza",
      "published": "Pubblicato",
      "collecting_quotes": "Raccogliere Quotazioni",
      "evaluation": "Valutazione",
      "awarded": "Premiato",
      "closed": "Chiuso",
      "cancelled": "Annullato",
      "active": "Attivo",
      "inactive": "Inattivo",
      "submitted": "Inviato",
      "invited": "Invitato",
      "viewed": "Vista",
      "pending": "In attesa",
      "sent": "Inviato",
      "failed": "Non riuscito",
      "sending": "Inviare",
      "reconciling": "Riconciliazione",
      "reconciliation_pending": "Riconciliazione",
      "board_approved": "Approvazione da parte del Consiglio",
      "approved": "Approvazione",
      "open": "Aperto",
      "rejected": "Rifiuti",
      "expired": "Scadenza",
      "revoked": "Votazioni",
      "reconciliation pending": "Riconciliazione"
    },
    "risk": {
      "critical": "Critico",
      "high": "Alto",
      "medium": "Medio",
      "low": "Basso",
      "unknown": "Sconosciuto"
    },
    "recommendation": {
      "renew": "Rinnovo",
      "renegotiate": "Renegoziato",
      "replace": "Sostituire",
      "review": "Recensione"
    },
    "category": {
      "products": "Prodotti",
      "services": "Servizi",
      "maintenance": "Manutenzione",
      "technology": "Tecnologia",
      "food_beverage": "Alimenti e bevande",
      "linen_laundry": "Biancheria e lavanderia",
      "landscaping": "Paesaggistica",
      "security": "Sicurezza",
      "other": "Altro",
      "Operating": "Funzionamento operativo",
      "CapEx": "Caps."
    },
    "criterion": {
      "cost": "Costo",
      "quality": "Qualità",
      "service": "Servizio"
    },
    "activity": {
      "RFQIssued": "Richiesta di preventivo emessa",
      "RFQUpdated": "RFQ aggiornato",
      "RFQSubmissionReceived": "Invio ricevuto",
      "RFQSubmissionEvaluated": "Sottomissione valutata",
      "RFQAwarded": "RFQ assegnato",
      "portal_link_generated": "Link del portale generato",
      "portal_link_regenerated": "Portal link rigenerato",
      "created": "RFQ creato",
      "updated": "RFQ aggiornato",
      "status_changed": "Stato cambiato",
      "bidder_invited": "Offerente invitato",
      "bidder_invite_email_sent": "Invia un'email di invito",
      "bidder_invitation_email_sent": "Invia un'email di invito",
      "bidder_invitation_email_failed": "Bidder invito email fallito",
      "bidder_promoted_to_supplier": "Bidder promosso a fornitore",
      "bidder_submission_file_uploaded": "Bidder allegato caricato",
      "budget_link_removed": "Collegamento di bilancio rimosso",
      "rfq_awarded": "RFQ assegnato",
      "rfq_awarded_without_board_approval": "RFQ assegnato senza approvazione del bordo",
      "sent_to_budget": "Invia a Bilancio",
      "submission_created": "Offerta creata",
      "submission_evaluated": "Offerta valutata",
      "submission_file_uploaded": "Offerta allegato caricato"
    },
    "market": {
      "Beef": "Carni bovine",
      "Pork": "Carne di maiale",
      "Poultry": "Pollame",
      "Dairy": "Latticini",
      "Fruits": "Frutta",
      "Vegetables": "Ortaggi",
      "Ribeye": "Ribeye.",
      "Striploin": "Spogliarellista",
      "Tenderloin": "Tendenze",
      "Bacon": "Pancetta",
      "Loins": "Los",
      "Hams": "Amle",
      "Boneless Breast": "Seno senza ossa",
      "Wings": "Ali per ali",
      "Whole Broilers": "Tutti i Broilers",
      "Butter": "Burro",
      "Cheddar": "Cheddar",
      "Milk": "Latte",
      "Apples": "Mele",
      "Grapes": "Uvaggio",
      "Strawberries": "Fragole",
      "Lettuce": "Lattuga",
      "Tomatoes": "Pomodori",
      "Onions": "Cipolle",
      "Food": "Cibo",
      "Fuel": "Carburante",
      "Energy": "Energia",
      "Linens": "Biancheria",
      "Maintenance": "Manutenzione",
      "Services": "Servizi",
      "Wine": "Vino",
      "Spirits": "Spiriti",
      "Premium Wine": "Vino Premium",
      "Investment Wine": "Vino di investimento",
      "Food Ingredients": "Ingredienti alimentari",
      "Packaging": "Imballaggio",
      "Meat": "Carni bovine"
    },
    "schedule": {
      "Hourly": "Ore",
      "Daily": "Quotidiano",
      "Monthly": "Mensile",
      "Real-time": "In tempo reale",
      "Intraday": "Infragiornaliero"
    },
    "region": {
      "US Markets": "Mercati americani",
      "National & Regional": "Nazionale e Regionale",
      "US Economic Data": "Dati economici USA",
      "Global": "Globale",
      "Global Fine Wine": "Vino di qualità globale",
      "Global Food Supply": "Fornitura alimentare globale",
      "Regional Fuel Markets": "Mercati regionali del carburante"
    },
    "trend": {
      "rising": "Crescita",
      "falling": "Caduta",
      "stable": "Stabile"
    },
    "unit": {
      "lb": "b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b) b)",
      "cwt": "Cw.",
      "bag": "borsa",
      "carton": "scatola di cartone"
    }
  },
  "outbound": {
    "greeting": "Ciao.",
    "greetingName": "Ciao {name},",
    "submit": "Invia il tuo preventivo",
    "questions": "Se hai domande, rispondi a questa e-mail.",
    "deadline": "Termine per la presentazione: {date}",
    "inviteSubject": "Sei invitato a presentare un preventivo: {title}",
    "inviteBody": "Sei invitato a presentare un preventivo per {number}: {title} .",
    "submitHere": "Inserisci il tuo preventivo qui: {url}",
    "receivedSubject": "Proposta pervenuta — {label}",
    "receivedBody": "Abbiamo ricevuto la vostra proposta per {label} .",
    "thanks": "Grazie per aver inviato la vostra risposta. Il nostro team lo esaminerà e seguirà se abbiamo bisogno di qualcos'altro.",
    "draftSubject": "Richiesta di quotazione: {number} — {title}",
    "draftBody": "Vorremmo invitare {name} a presentare una quotazione per {number}: {title} .",
    "responseNotification": "{name} ha risposto alla tua RFQ: {title}"
  },
  "errors": {
    "ai_invalid_json": "Il RFQ generato non poteva essere letto. Si prega di riprovare.",
    "ai_invalid_response": "Il RFQ generato è incompleto. Si prega di riprovare.",
    "award_submission_not_budgeted": "L'offerta selezionata non corrisponde all'offerta di bilancio.",
    "bidder_not_found": "Bidder non trovato.",
    "budget_line_not_found": "Linea di bilancio non trovata.",
    "budget_missing_current_version": "Questo budget non ha una versione attuale.",
    "budget_not_board_approved": "Il bilancio richiede l'approvazione del consiglio di amministrazione.",
    "budget_not_found": "Bilancio non trovato.",
    "budget_submission_missing": "Seleziona un'offerta da inviare a Budget.",
    "club_currency_fetch_failed": "La valuta del club non poteva essere caricata.",
    "club_identity_unavailable": "Le informazioni del club non sono disponibili.",
    "currency_mismatch": "La valuta di offerta deve corrispondere alla valuta del club.",
    "description_required": "È richiesta una descrizione.",
    "draft_not_found": "Progetto di invito non trovato.",
    "duplicate_or_invalid_bidder": "Un offerente selezionato è invalido o duplicato.",
    "file_not_found": "File non trovato.",
    "file_too_large": "Il file supera il limite di dimensione di upload.",
    "file_upload_failed": "Il file non potrebbe essere caricato.",
    "invalid_bidders": "Seleziona offerte valide.",
    "invalid_budget_line_id": "Selezionare una linea di bilancio valida.",
    "invalid_club_code": "Il club non poteva essere identificato.",
    "invalid_contact_email": "Inserisci un indirizzo email di contatto valido.",
    "invalid_criteria": "Controllare i criteri di valutazione.",
    "invalid_file_type": "Questo tipo di file non è supportato.",
    "invalid_limit": "La dimensione della pagina richiesta non è valida.",
    "invalid_multipart": "Il caricamento non poteva essere letto. Selezionare il file di nuovo.",
    "invalid_offset": "La pagina richiesta non è valida.",
    "invalid_request": "Controlla il modulo e riprova.",
    "invalid_scores": "Controllare che i punteggi di valutazione sono all'interno della gamma consentita.",
    "invalid_status": "Selezionare uno stato valido.",
    "invalid_status_transition": "Questo cambiamento di stato non è consentito.",
    "invite_not_found": "Invito non trovato.",
    "mailbox_changed_regenerate_drafts": "La tua casella di posta è cambiata, genera di nuovo le bozze d'invito.",
    "missing_bidder_email": "Aggiungi un indirizzo e-mail per questo offerente.",
    "missing_file": "Selezionare un file da caricare.",
    "missing_required_fields": "Completare i campi richiesti.",
    "name_required": "È richiesto un nome di offerente.",
    "need_text_required": "Descrivi il tuo bisogno di approvvigionamento.",
    "need_text_too_long": "Mantenere la necessità di approvvigionamento entro 4.000 caratteri.",
    "no_updates": "Non sono state apportate modifiche.",
    "rate_limit_exceeded": "Troppe richieste. Si prega di riprovare più tardi.",
    "rate_limited": "Troppe richieste. Si prega di riprovare più tardi.",
    "recipient_must_match_bidder_contact": "Il destinatario deve corrispondere al contatto selezionato del offerente.",
    "rfq_already_awarded": "Questo RFQ è già stato assegnato.",
    "rfq_already_sent_to_budget": "Questo RFQ è già stato inviato a Budget.",
    "rfq_not_accepting_submissions": "Questo RFQ non accetta offerte.",
    "rfq_not_awarded": "Premi questo RFQ prima di promuovere il suo offerente.",
    "rfq_not_eligible": "Questo RFQ non è idoneo per questa azione.",
    "rfq_not_found": "RFQ non trovato.",
    "rfq_not_sent_to_budget": "Mandate prima questo RFQ a Budget.",
    "scoring_template_not_found": "Modello di punteggio non trovato.",
    "send_in_progress": "Questa e-mail è già stata inviata.",
    "send_reconciliation_pending": "La consegna viene controllata, si prega di attendere prima di riprovare.",
    "send_reconciliation_required": "La consegna deve essere controllata prima di riprovare.",
    "submission_failed": "L'offerta non potrebbe essere presentata. Si prega di riprovare.",
    "submission_not_found": "Offerta non trovata.",
    "submission_rfq_mismatch": "Questa offerta appartiene ad una diversa RFQ.",
    "weights_must_sum_to_100": "I pesi di valutazione devono essere al 100%."
  },
  "newActions": {
    "review": "Riunione di revisione delle prestazioni",
    "research": "Ricerca di offerte alternative",
    "negotiate": "Preparare la strategia di negoziazione",
    "terms": "Termini e condizioni del contratto di revisione"
  },
  "contractDefault": "{rfq} Contratto premiato",
  "dayValue": "{count} giorno",
  "showingOne": "Mostrando {start} – {end} di {total} offerente",
  "emailSentOne": "E-mail inviata a {count} destinatario!"
};
